import { Editor } from "@tiptap/react";
import { EditorState } from "@tiptap/pm/state";
import { EditorView } from "@tiptap/pm/view";

import { TableMap } from "@tiptap/pm/tables";

import { findTable, isTableSelected } from "../../utils.js";
import Table from "../../Table.js";

export const isColumnGripSelected = ({
  editor,
  view,
  state,
  from,
}: {
  editor: Editor;
  view: EditorView;
  state: EditorState;
  from: number;
}) => {
  const domAtPos = view.domAtPos(from).node as HTMLElement;
  const nodeDOM = view.nodeDOM(from) as HTMLElement;
  const node = nodeDOM || domAtPos;

  if (!editor.isActive(Table.name) || !node) {
    return false;
  }

  // One-column tables: selecting that column selects every cell, so isTableSelected is
  // true — still show the column menu so users can add columns.
  const table = findTable(state.selection);
  if (table && isTableSelected(state.selection)) {
    const map = TableMap.get(table.node);
    if (map.width !== 1) {
      return false;
    }
  }

  let container = node;

  while (container && !["TD", "TH"].includes(container.tagName)) {
    container = container.parentElement!;
  }

  const gripColumn =
    container &&
    container.querySelector &&
    container.querySelector("a.grip-column.selected");

  return !!gripColumn;
};

export default isColumnGripSelected;
